import { Link } from 'react-router-dom';

export const getLinkProps = (link?: string) => {
    if (!link) {
        return {};
    }

    return {
        as: Link,
        to: link,
        textDecoration: 'none',
        style: { color: 'inherit' },
    };
};
